import { jsonOrTextFromResponse, ocultarSpinner, mostrarSpinner, renderAlertas, eliminarErroresSpan} from "./utils.js";
import { mostrarMensajeError, mostrarMensajeExito } from "./swal.js";
import {CAPTCHA_PUBLIC_KEY} from "./app.js";

const enviarBtn  = document.querySelector('#enviar');
const formContacto = document.querySelector('#formContactanos');

if(enviarBtn && formContacto){
    
    formContacto.addEventListener('submit', async (e)=>{
        e.preventDefault();
        eliminarErroresSpan();
        
        mostrarSpinner();
        let exito = false;
        
        grecaptcha.ready(async function() {
            try {
                
                const token = await grecaptcha.execute(CAPTCHA_PUBLIC_KEY, {action: 'submit_form'});
                document.getElementById('recaptchaResponse').value = token;
                
                const formData = new FormData(formContacto);
                const response = await fetch('/contactanos', {
                    method: 'POST',
                    body: formData
                });
    
                const contentResponse = await jsonOrTextFromResponse(response);
                if(typeof contentResponse === 'object'){
                    if('error' in contentResponse){
                        renderAlertas(contentResponse, {ubicacion: 'arriba'});
                        exito = false;
                        if(contentResponse.error === 'No se pudo enviar el mensaje'){
                            formContacto.reset();
                            throw new Error(contentResponse.error);
                        }
                        
                    }else{
                        formContacto.reset();
                        exito = true;
                    }
                }
            } catch (error) {
                console.log(`Error el enviar formulario de contacto: ${error}`);
                ocultarSpinner();
                await mostrarMensajeError({title: 'Error de envío', text: 'No se pudo procesar tu solicitud. Inténtalo de nuevo.', timer: null});
                exito = false;
            } finally {
                ocultarSpinner();
                if(exito){
                    await mostrarMensajeExito({title: 'Gracias por escribirnos', text: 'Pronto nos contactaremos contigo.', timer: 3000});
                }
            }
        }); //fin recaptcha

    })
}

